export default __webpack_public_path__ + "static/media/CTP_Dark_SP.a1d27151.svg";